import { render, staticRenderFns } from "./DesignerDeposits.vue?vue&type=template&id=75067388&scoped=true&"
import script from "./DesignerDeposits.vue?vue&type=script&lang=js&"
export * from "./DesignerDeposits.vue?vue&type=script&lang=js&"
import style0 from "./DesignerDeposits.vue?vue&type=style&index=0&id=75067388&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75067388",
  null
  
)

export default component.exports